import React from 'react';

const ErrorPage = () => <div>something happened. Please refresh the page.</div>;

export default ErrorPage;
